import { render } from "./EmbedSettings.vue?vue&type=template&id=46de3446"
import script from "./EmbedSettings.vue?vue&type=script&lang=js"
export * from "./EmbedSettings.vue?vue&type=script&lang=js"

import "./EmbedSettings.vue?vue&type=style&index=0&id=46de3446&lang=scss"

import exportComponent from "/app/tmp/alangray/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__